<div class="example-container">
  <div class="filter-row">
    <div class="selects-group">
      <mat-form-field class="filter-field">
        <mat-label>Country (Management ID)</mat-label>
        <mat-select [(ngModel)]="selectedManagementId" (selectionChange)="onChangeManagementId()">
          @for (mgmtId of managementIds; track mgmtId.value) {
            <mat-option [value]="mgmtId.value">
              {{ mgmtId.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>Operational System</mat-label>
        <mat-select [(ngModel)]="selectedOperationalSystem" (selectionChange)="onChangeOperationalSystem()" [disabled]="!selectedManagementId">
          @for (system of operationalSystems; track system) {
            <mat-option [value]="system.SystemId">
              {{ system.SystemName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field class="search-input">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyTextFilter($event)">
    </mat-form-field>

    <div class="actions-group">
      <button mat-raised-button class="unmapped-only-button" (click)="filterUnmapped()" matTooltip="Show only unmapped products">
        <mat-icon>warning</mat-icon> Unmapped Only
      </button>
      <button mat-raised-button class="clear-filter-button" (click)="clearFilter()" matTooltip="Clear filters">
        <mat-icon>clear</mat-icon> Clear
      </button>
    </div>
  </div>

  <table mat-table #itemsList
    [dataSource]="dataSource"
    class="mat-elevation-z8 mat-table-custom"
    id="productmapping">

    <ng-container matColumnDef="TenantId">
      <th mat-header-cell *matHeaderCellDef> Tenant ID </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.TenantId ?? 'No value'"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="ManagementId">
      <th mat-header-cell *matHeaderCellDef> Management ID </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.ManagementId ?? ''"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="OperationalSystem">
      <th mat-header-cell *matHeaderCellDef> Operational System </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.OperationalSystem ?? ''"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="LocalProductName">
      <th mat-header-cell *matHeaderCellDef> Local Product Name </th>
      <td mat-cell *matCellDef="let element" [class.unmapped-highlight]="isUnmapped(element)">
        <div>
          @if (isUnmapped(element)) {
            <mat-icon
              class="unmapped-warning-icon"
              matTooltip="Unmapped product">
              warning
            </mat-icon>
          }
          <p [innerHTML]="element.LocalProductName ?? ''"></p>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="GlobalProductName">
      <th mat-header-cell *matHeaderCellDef> Global Product Name </th>
      <td mat-cell *matCellDef="let element" [class.unmapped-highlight]="isUnmapped(element)">
        @if (!isEditingRow(element)) {
          <p [innerHTML]="element.GlobalProductName ?? 'Unmapped'" [class.unmapped-text]="isUnmapped(element)">
            @if (isUnmapped(element)) {
              <span class="not-mapped-label">Not mapped</span>
            }
            @if (!isUnmapped(element)) {
              <span>{{element.GlobalProductName}}</span>
            }
          </p>
        }
        @if (isEditingRow(element)) {
          <mat-form-field floatLabel="always" class="global-product-select">
            <mat-select [(ngModel)]="element.GlobalProductName"
              (selectionChange)="changeGlobalProduct($event, element)"
              placeholder="Select global product"
              class="centered-select">
              <mat-option [value]="null">-- Unmap --</mat-option>
              @for (product of globalProducts; track product) {
                <mat-option [value]="product.ProductDescription">
                  {{ product.ProductDescription }} ({{ product.KpiProductHierarchyId }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        @if (!isEditingRow(element)) {
          <button mat-icon-button matTooltip="Edit Mapping"
            (click)="onRowEditInit(element)">
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (isEditingRow(element)) {
          <button mat-icon-button matTooltip="Cancel Edit"
            (click)="onRowEditCancel(element)">
            <mat-icon>rotate_left</mat-icon>
          </button>
        }
        <button mat-icon-button matTooltip="View History"
          (click)="onGetHistory(element)">
          <mat-icon>history</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="savefooter">
      <th mat-footer-cell *matFooterCellDef colspan="6">
        <div class="OrangeButton">
          <button mat-raised-button
            type="submit"
            (click)="onSave()"
            [disabled]="!isAnyRowEditing()"
            [matTooltip]="isAnyRowEditing() ? 'Save changes' : 'Save disabled'"
            class="button-color-fix pull-right">
            Save
            <mat-icon class="icon-color-fix save-icon-white">save</mat-icon>
          </button>
        </div>
      </th>
    </ng-container>

    <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="item"
      [class.alternative2]="isEditingRow(element)"
      [class.unmapped-row]="isUnmapped(element)">
    </tr>
  </table>

  @if (dataSource.data.length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-state-icon">info</mat-icon>
      <p>No product mappings found.</p>
    </div>
  }
</div>